import { CerillionStage, OrderStatus } from '../../../types/orderRecord';

export const formatOrderStatus = (state: OrderStatus | CerillionStage) => state.replaceAll('_', ' ');
